import { CoolerTypeField } from "components/fields/CoolerTypeField";
import { FakeReferenceTextField } from "components/fields/FakeReferenceTextField";
import { AppList } from "components/list/AppList";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { DeleteButton } from "components/toolbars/DeleteButton";
import { PalletType } from "entities/PalletType";
import React, { useMemo } from "react";
import { Datagrid, FunctionField, TextField } from "react-admin";
import { useLocation } from "react-router-dom";

import { EmptyProductArticles } from "./EmptyProductArticles";
import { ProductArticlesFilter } from "./ListFilters";
import { ProductArticlesActions } from "./ProductArticlesActions";
import { UpdateProductArticle } from "./UpdateProductArticle";


export const ProductArticlesList = ({ companyId, resource, ...props }) => {
	const location = useLocation();
	const filterDefaultValues = useMemo(() => {
		try {
			const params = new URLSearchParams(location.search);
			const filterParam = params.get("filter");
			if (filterParam) {
				return JSON.parse(filterParam);
			}
		} catch (e) {
			// ignore invalid filter param
		}
		return undefined;
	}, [location.search]);

	return (
		<AppList
			{...props}
			resource={resource}
			filters={<ProductArticlesFilter />}
			bulkActionButtons={false}
			exporter={false}
			actions={<ProductArticlesActions companyId={companyId} />}
			filter={{ company_id: companyId }}
			filterDefaultValues={filterDefaultValues}
			hasCreate={true}
			empty={<EmptyProductArticles companyId={companyId} />}
		>
			<Datagrid>
				<TextField source="id" />
				<TextField source="product_number" />
				<TextField source="product_name" />
				<FakeReferenceTextField source="commodity_id" replaceSource="commodity_name" />
				<TextField source="default_box_weight" />
				<CoolerTypeField
					source="default_temperature"
					label="resources.product-articles.fields.default_temperature"
				/>
				<SelectEnumField
					source="default_pallet_type"
					enumName="pallet_type"
					enumObj={PalletType}
					label="resources.product-articles.fields.default_pallet_type"
				/>
				<TextField source="default_unit_per_pallets" />
				<FunctionField
					source=""
					render={(record) => <UpdateProductArticle productArticle={record} />}
				/>
				<FunctionField
					render={(record) => (
						<DeleteButton
							resource={resource}
							notifyMessage="osfc.dialogs.confirm_delete_product_articles.success"
							title="osfc.dialogs.confirm_delete_product_articles.confirm.title"
							content="osfc.dialogs.confirm_delete_product_articles.confirm.content"
						/>
					)}
				/>
			</Datagrid>
		</AppList>
	);
};
